import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import browserClient from '@slardar/web';
import App from './App';
import { routes } from './routes/index';
import './utils/responsive';

browserClient('init', {
  bid: 'chartspace_site',
  env: __DEV__ ? 'test' : `production(${location.host})`,
});
browserClient('start');

startTransition(() => {
  hydrateRoot(
    document.getElementById('root')!,
    <StrictMode>
      <App hostname={location.hostname} userAgent={navigator.userAgent}>
        <RouterProvider router={createBrowserRouter(routes)} />
      </App>
    </StrictMode>
  );
});
